import { render, staticRenderFns } from "./InputsBettingArea.vue?vue&type=template&id=339b9a91&scoped=true"
import script from "./InputsBettingArea.vue?vue&type=script&lang=js"
export * from "./InputsBettingArea.vue?vue&type=script&lang=js"
import style0 from "./InputsBettingArea.vue?vue&type=style&index=0&id=339b9a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339b9a91",
  null
  
)

export default component.exports